/* eslint-disable max-classes-per-file */

import {
  ResponseCommonPresenter,
  ResponsePresenter,
} from "../../common/commonClassPresenter";
import { ExpirePaymentDatePresenter } from "../../history/historyServiceInterface/historyBookingCommonInterface";

class AccountSocialClass {
  id: string;

  accountId: string;

  socialId: string;

  socialType: string;

  createdAt: string;

  updatedAt: string;

  socialProfile: string;

  constructor(data: any) {
    this.id = data?.id || "";
    this.accountId = data?.account_id || "";
    this.socialId = data?.social_id || "";
    this.socialType = data?.social_type || "";
    this.createdAt = data?.created_at || "";
    this.updatedAt = data?.updated_at || "";
    this.socialProfile = data?.social_profile || "";
  }
}
export class ResponseProfilePresenter extends ResponseCommonPresenter {
  isNewAccount: boolean;

  submitDelete: string;

  activeUntil: string;

  account: {
    id: string;
    // token: string;
    titlename: string;
    firstname: string;
    lastname: string;
    countryOfPassport: string;
    birthday: string;
    prefixPhone: string;
    phoneNumber: string;
    email: string;
    agentId: string;
    imagepath: string;
    updatedAt: string;
    createdAt: string;
    isSubscribe: number;
    isActive: number;
    isPassword: number;
    isBirthdayEdit: number;
    loyaltyLevel: string;
  };

  accountSocial: AccountSocialClass[];

  constructor(data: any) {
    super(data);
    this.status = data?.status || false;
    this.message = data?.message || "";
    this.isNewAccount = data?.is_new_account || false;
    this.submitDelete = data?.submit_delete || "";
    this.activeUntil = data?.active_until || "";
    this.account = {
      id: data?.account?.id || "",
      // token: data?.account?.token || "",
      titlename: data?.account?.titlename || "",
      firstname: data?.account?.firstname || "",
      lastname: data?.account?.lastname || "",
      countryOfPassport: data?.account?.country_of_passport || "",
      birthday: data?.account?.birthday || "",
      prefixPhone: data?.account?.prefix_phone || "",
      phoneNumber: data?.account?.phone_number || "",
      email: data?.account?.email || "",
      agentId: data?.account?.agent_id || "",
      imagepath: data?.account?.imagepath || "",
      updatedAt: data?.account?.updated_at || "",
      createdAt: data?.account?.created_at || "",
      isSubscribe: data?.account?.is_subscribe || 0,
      isActive: data?.account?.is_active || 0,
      isPassword: data?.account?.is_password || 0,
      isBirthdayEdit: data?.account?.is_birthday_edit || 0,
      loyaltyLevel: data?.account?.loyalty_level
        ? String(data?.account?.loyalty_level)
        : "",
    };
    this.accountSocial = (data?.account_social || []).map(
      (results: any) => new AccountSocialClass(results),
    );
  }
}
export class ResponseCommonWithTokenPresenter extends ResponseCommonPresenter {
  token: string;

  constructor(response: any) {
    super(response);
    this.token = response?.token || "";
  }
}
class ResponseCommonSendCodeVerificationPresenter {
  round: string;

  expire: string;

  expireSeconds: number;

  isBlock: boolean;

  blockData: {
    resendInTime: string;
    resendInSeconds: number;
    resendInMinutes: number;
  };

  ref: string;

  constructor(response: any) {
    this.round = response?.round || "";
    this.expire = response?.expire || "";
    this.expireSeconds = response?.expireSeconds || 0;
    this.isBlock = response?.isBlock || false;
    this.blockData = {
      resendInTime: response?.blockData?.resendInTime || "",
      resendInSeconds: response?.blockData?.resendInSeconds || 0,
      resendInMinutes: response?.blockData?.resendInMinutes || 0,
    };

    this.ref = response?.ref || "";
  }
}

export class DataSendCodeVerificationSmsPresenter extends ResponseCommonSendCodeVerificationPresenter {
  prefixPhone: string;

  phoneNumber: string;

  constructor(response: any) {
    super(response);
    this.prefixPhone = response?.prefixPhone || "";
    const phone =
      this.prefixPhone === "66"
        ? response?.phoneNumber?.replace(/^0/, "")
        : response?.phoneNumber;
    this.phoneNumber = phone || "";
  }
}
export class DataSendCodeVerificationMailPresenter extends ResponseCommonSendCodeVerificationPresenter {
  email: string;

  constructor(response: any) {
    super(response);
    this.email = response?.email || "";
  }
}
export class ResponsePostSendCodeVerificationMailPresenter extends ResponsePresenter<DataSendCodeVerificationMailPresenter> {
  constructor(response: any) {
    super(response, (data) => new DataSendCodeVerificationMailPresenter(data));
  }
}
export class ResponsePostSendCodeVerificationSmsPresenter extends ResponsePresenter<DataSendCodeVerificationSmsPresenter> {
  constructor(response: any) {
    const responsePresent = {
      ...response,
      data: { ...response?.data, expireSeconds: response?.expireSeconds },
    };

    super(
      responsePresent,
      (data) => new DataSendCodeVerificationSmsPresenter(data),
    );
  }
}

export class ResponsePostCheckExistingEmailPresenter extends ResponseCommonPresenter {
  email: string;

  emailStatus: string; // NOTE - รับ status จาก api ตอนเป็น string (บอก status ของ email)

  token: string;

  social: AccountSocialClass[];

  constructor(response: any) {
    super(response);
    this.email = response?.email || "";
    this.emailStatus = response?.status || "";
    this.token = response?.token || "";
    this.social = (response?.social || []).map(
      (results: any) => new AccountSocialClass(results),
    );
  }
}

class BlockDataPresenter {
  resendInTime: string;

  resendInSeconds: number;

  resendInMinutes: number;

  constructor(response: any) {
    this.resendInTime = response?.resendInTime || "";
    this.resendInSeconds = response?.resendInSeconds || 0;
    this.resendInMinutes = response?.resendInMinutes || 0;
  }
}

class DataSendOtpPresenter {
  round: string;

  expire: string;

  expireSeconds: number;

  isBlock: boolean;

  email: string;

  ref: string;

  cooldown: string;

  cooldownSeconds: number;

  blockData: BlockDataPresenter;

  constructor(response: any) {
    this.round = response?.round || "";
    this.expire = response?.expire || "";
    this.expireSeconds = response?.expireSeconds || 0;
    this.isBlock = response?.isBlock || false;
    this.email = response?.email || "";
    this.ref = response?.ref || "";
    this.cooldown = response?.cooldown || "";
    this.cooldownSeconds = response?.cooldownSeconds || 0;
    this.blockData = new BlockDataPresenter(response?.blockData);
  }
}

class VerifyOtpPresenter {
  round: string;

  isBlock: boolean;

  cooldown: string;

  cooldownSeconds: number;

  token: string;

  blockData: BlockDataPresenter;

  constructor(response: any) {
    this.round = response?.round || "";
    this.isBlock = response?.isBlock || false;
    this.cooldown = response?.cooldown || "";
    this.cooldownSeconds = response?.cooldownSeconds || 0;
    this.token = response?.token || "";
    this.blockData = new BlockDataPresenter(response?.blockData);
  }
}

export class DataSendOtpSMSPresenter extends DataSendOtpPresenter {
  prefixPhone: string;

  phoneNumber: string;

  constructor(response: any) {
    super(response);
    this.prefixPhone = response?.prefixPhone || "";
    const phone =
      this.prefixPhone === "66"
        ? response?.phoneNumber?.replace(/^0/, "")
        : response?.phoneNumber;
    this.phoneNumber = phone || "";
  }
}

export class DataSendOtpMailPresenter extends DataSendOtpPresenter {
  email: string;

  constructor(response: any) {
    super(response);
    this.email = response?.email || "";
  }
}
export class DataSendSMSVerificationPresenter {
  sendOtp: DataSendOtpSMSPresenter;

  verifyOtp: VerifyOtpPresenter;

  isPhoneExist: boolean;

  phoneNumber: string;

  prefixPhone: string;

  constructor(response: any) {
    this.sendOtp = new DataSendOtpSMSPresenter(response?.sendOtp);
    this.verifyOtp = new VerifyOtpPresenter(response?.verifyOtp);
    this.isPhoneExist = response?.isPhoneExist || false;
    this.phoneNumber = response?.phoneNumber || "";
    this.prefixPhone = response?.prefixPhone || "";
  }
}

export class DataSendMailVerificationPresenter {
  sendOtp: DataSendOtpMailPresenter;

  verifyOtp: VerifyOtpPresenter;

  constructor(response: any) {
    this.sendOtp = new DataSendOtpMailPresenter(response?.sendOtp);
    this.verifyOtp = new VerifyOtpPresenter(response?.verifyOtp);
  }
}

export class ResponsePostSendSMSVerificationPresenter extends ResponsePresenter<DataSendSMSVerificationPresenter> {
  constructor(response: any) {
    super(response, (data) => new DataSendSMSVerificationPresenter(data));
  }
}

export class ResponsePostSendCodeVerificationMailV5Presenter extends ResponsePresenter<DataSendMailVerificationPresenter> {
  constructor(response: any) {
    super(response, (data) => new DataSendSMSVerificationPresenter(data));
  }
}
class DataPaymentAddBookingToAccount {
  paymentUrl: string;

  isAllocatesExpire: boolean;

  expireAllocateDate: ExpirePaymentDatePresenter;

  constructor(response: any) {
    this.paymentUrl = response?.paymentUrl || "";
    this.isAllocatesExpire = response?.isAllocatesExpire || false;
    this.expireAllocateDate = new ExpirePaymentDatePresenter(
      response?.expireAllocateDate,
    );
  }
}
export class DataAddBookingToAccountPresenter {
  bookingInternalNo: string;

  productType: string;

  paymentStatus: string;

  payment: DataPaymentAddBookingToAccount;

  constructor(response: any) {
    this.bookingInternalNo = response?.bookingInternalNo || "";
    this.productType = response?.productType || "";
    this.paymentStatus = (response?.paymentStatus || "").toLocaleLowerCase();
    this.payment = new DataPaymentAddBookingToAccount(response?.payment);
  }
}

export class ResponsePostAddBookingToAccountPresenter extends ResponsePresenter<DataAddBookingToAccountPresenter> {
  constructor(response: any) {
    super(response, (data) => new DataAddBookingToAccountPresenter(data));
  }
}
